import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'

// Reducers
import * as ProfileReducer from '../../reducers/profile'

// Config
import { getUserProfilePicture } from '../../config'
import colors, { materialGreens } from '@fe/ui/colors'

// Material UI things
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  avatar: {
    width: 120,
    height: 120,
    borderRadius: 60,
    margin: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonProgress: {
    color: materialGreens[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
})

const stringScaler = (stringSize, scale = 1) => {
  if (_.isNumber(stringSize)) {
    return stringSize * scale
  }
  const parts = _.split(/(\d+)/, stringSize)
  if (_.size(parts) === 3) {
    return `${_.toNumber(parts[1]) * scale}${parts[2]}`
  }
  return stringSize
}

const ProfileImageBase = ({ classes, profile, style = {}, rim = false, backgroundColor = colors.primaryDarkGreen, size = 120, textColor = colors.white }) => {
  const initials = React.useMemo(() => {
    const firstLetters = _.flow(_.words, _.map(_.first))(_.get('name', profile))
    if (_.size(firstLetters) > 1) {
      return `${_.first(firstLetters)}${_.last(firstLetters)}`
    }
    return _.first(firstLetters)
  }, [profile])

  const innerSize = React.useMemo(() => {
    return ({
      width: size,
      height: size,
      borderRadius: stringScaler(size, 0.5)
    })
  }, [size])

  const outerSize = React.useMemo(() => {
    if (!rim) {
      return ({
        ...innerSize
      })
    }
    const rimmedSize = stringScaler(size, 1.1)
    return ({
      width: rimmedSize,
      height: rimmedSize,
      borderRadius: stringScaler(rimmedSize, 0.5)
    })
  }, [size])

  return (
    <div className={classes.avatar} style={{ ...style, ...outerSize, backgroundColor }}>
      <div style={{ ...innerSize, backgroundImage: `url(${getUserProfilePicture(profile)})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {!(_.get('profile_filename', profile) || _.get('profileFilename', profile)) && (
          <Typography variant={innerSize.height > 100 ? 'h3' : 'h5'} style={{ color: textColor }}>
            {_.upperCase(initials)}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default _.compose(
  withStyles(styles),
  connect(
    (s, ownProps) => {
      const profile = _.get('profile', ownProps) || ProfileReducer.selectors.getProfile(s)
      return { profile }
    },
    (_dispatch, _ownProps) => ({})
  )
)(ProfileImageBase)
